export const environment = "production";
export const google_site_key_v3 = "6LfhLKQkAAAAADv4QLes3emiEmZx7ReBBiT6YbBN";
const local = {
  baseurl: "http://localhost/zyratalkcode",
}

const development = {
  baseurl: "https://dev.zyratalk.com",
}

const uat = {
  baseurl: "https://uat.zyratalk.com",
}

const production = {
  baseurl: "https://www.zyratalk.com",
}

const config =
  environment === "production"
    ? production
    : environment === "uat"
      ? uat
      : environment === "development"
        ? development
        : local;

export default config;